'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.trim = trim;
exports.isAndroid = isAndroid;
exports.isIOS = isIOS;
exports.isWeChat = isWeChat;
exports.isAndroidWeChat = isAndroidWeChat;
exports.isIOSWeChat = isIOSWeChat;
exports.isWindowsWechat = isWindowsWechat;
exports.typeOf = typeOf;
exports.isObject = isObject;
exports.encodeSearchParams = encodeSearchParams;
exports.decodeHTMLEntities = decodeHTMLEntities;
exports.mapProperties = mapProperties;
var REGEXP_SPACES = /^\s+(.*)\s+$/;

/**
 * 去除字符串首尾空格
 * @param {string} str - 待处理字符串
 * @returns {string} 已去除首尾空格的字符串
 */
function trim(str) {
  str = String(str);

  if (str.trim) {
    return str.trim();
  }

  return str.replace(REGEXP_SPACES, '$1');
}

var userAgent = global.navigator.userAgent;
var inAndroid = /Android/i.test(userAgent);
var inIOS = /iPhone|iPad|iPod/i.test(userAgent);
var inMicroMessenger = /MicroMessenger/i.test(userAgent);
var inWindowsWechat = /WindowsWechat/i.test(userAgent);

/**
 * 判断当前系统是否是Android系统
 * @returns {boolean} 是与否
 */
// eslint-disable-next-line
function isAndroid() {
  return inAndroid;
}

/**
 * 判断当前系统是否是iOS系统
 * @returns {boolean} 是与否
 */
function isIOS() {
  return inIOS;
}

/**
 * 判断当前浏览器环境是否是微信
 * @returns {boolean} 是与否
 */
function isWeChat() {
  return inMicroMessenger;
}

/**
 * 判断当前浏览器环境是否是Android版微信
 * @returns {boolean} 是与否
 */
function isAndroidWeChat() {
  return inAndroid && inMicroMessenger;
}

/**
 * 判断当前浏览器环境是否是iOS版微信
 * @returns {boolean} 是与否
 */
function isIOSWeChat() {
  return inIOS && inMicroMessenger;
}

/**
 * 判断当前浏览器环境是否是Windows版微信
 * @returns {boolean} 是与否
 */
function isWindowsWechat() {
  return inWindowsWechat && inMicroMessenger;
}

var toString = Object.prototype.toString;

/**
 * 判断一个变量哪种类型
 * @param {*} obj - 待判断变量
 * @returns {string} 类型名称
 */
function typeOf(obj) {
  return toString.call(obj).slice(8, -1).toLowerCase();
}

/**
 * 判断一个变量是否是非null对象
 * @param {*} obj - 待判断变量
 * @returns {boolean} 是与否
 */
function isObject(obj) {
  return (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && obj !== null;
}

var encodeURIComponent = global.encodeURIComponent;

/**
 * 拼接对象为请求字符串
 * @param {Object} obj - 待拼接的对象
 * @returns {string} - 拼接成的请求字符串
 */
function encodeSearchParams(obj) {
  var params = [];

  Object.keys(obj).forEach(function (key) {
    var value = obj[key];

    if (typeof value === 'undefined') {
      value = '';
    }

    params.push([key, encodeURIComponent(value)].join('='));
  });

  return params.join('&');
}

var REGEXP_HTML_ENTITIES = /&lt;(\/?)(\w+)(.*?)(\/?)&gt;/ig;

/**
 * 解码HTML实体
 * @param {string} html - 待解码的HTML字符串
 * @returns {string} 已解码的HTML字符串
 */
function decodeHTMLEntities(html) {
  return String(html).replace(REGEXP_HTML_ENTITIES, function (tag, startSprit, tagName, attrs, endSprit) {
    if (tagName.toLowerCase() === 'script') {
      return tag;
    }

    return '<' + startSprit + tagName + attrs + endSprit + '>';
  });
}

/**
 * 复制指定属性到一个新对象
 * @param {Object} obj - 被复制的对象
 * @param {Array} [keys] - 需要被复制的属性名数组
 * @returns {Object} 复制出来的对象
 */
function mapProperties(obj) {
  var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var data = {};

  Object.keys(obj).forEach(function (key) {
    if (keys.indexOf(key) > -1) {
      data[key] = obj[key];
    }
  });

  return data;
}


//////////////////
// WEBPACK FOOTER
// ./src/utils/index.js
// module id = 156
// module chunks = 14